/*
* @Des 弹窗组件 电子围栏
* @Description
* @Author
* @Date  2021/8/2
*/
/* HTML */
<template>
    <el-dialog :title="dialogForm.title"
               :visible.sync="dialogForm.dialogFormVisible"
               :close-on-click-modal="false"
               custom-class="form-dialog forms-box"
               v-dialogDrag
               class="dialog_title"
               @close="handleDialogClose"
    >
        <el-form :model="dialogRowForm" :rules="rules" ref="dialogRowForm" label-width="" style="max-height: 100%;overflow-y: auto;">
            <el-form-item class="row-items-2" label="围栏名称：" prop="eName">
                <el-input v-model="dialogRowForm.eName" clearable />
            </el-form-item>
            <el-form-item class="row-items-2" label="处理方式：" prop="dealMethod">
                <el-select v-model="dialogRowForm.dealMethod" placeholder="请选择处理方式" >
                    <el-option v-for="(item,index) in dealMethods" :key="item.val" :label="item.label" :value="item.val" ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item v-if="dialogRowForm.eType == 7" class="row-items-2 paddingT-20 inp-pdr-20" label="聚众范围：" prop="range" style="">
                <i style="color: #dcdfe6;font-style: normal;position: absolute;left: calc(50% - 34px);z-index: 1;">米</i>
                <i style="color: #dcdfe6;font-style: normal;position: absolute;left: calc(100% - 20px);z-index: 1;">米</i>
                <el-input v-model="dialogRowForm.rangeX" clearable style="width: calc((100% - 32px)/2)!important;clear: both;" placeholder="长"/>
                <span style="font-size: 20px;line-height: 40px;color: #e6e6e6;padding: 0 5px;vertical-align: middle;">X</span>
                <el-input v-model="dialogRowForm.rangeY" clearable style="width: calc((100% - 32px)/2)!important;" placeholder="宽"/>
            </el-form-item>
            <el-form-item v-if="dialogRowForm.eType == 7" class="row-items-2" label="聚众人数：" prop="peopleNum">
                <el-input v-model="dialogRowForm.peopleNum" clearable />
            </el-form-item>

            <el-form-item v-if="dialogRowForm.eType == 8" class="row-items-2" label="周界阈值（米）：" prop="borderDis">
                <el-input v-model="dialogRowForm.borderDis" clearable />
            </el-form-item>
            <el-form-item v-if="dialogRowForm.eType == 8" class="row-items-2" label="周界类型" prop="borderType">
				<el-select v-model="dialogRowForm.borderType" placeholder="请选择周界类型">
                    <el-option v-for="(item,index) in borderTypes" :key="item.val" :label="item.label" :value="item.val" ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item class="row-items-1 paddingT-30" label="选择人员组：" prop="timeSlot">

                <!-- 穿梭框 -->
				<!--<el-transfer
					style="padding-top: 30px;"
					filterable
					:filter-method="filterMethod"
					filter-placeholder="请输入人员组编号/人员组序列号"
					:titles="['未关联人员组', '已关联人员组']"
					v-model="dialogRowForm.userGroup"
					:data="userGroupList">
				</el-transfer>-->

				<tree-transfer
					:title="treeTransferForm.title"
					:from_data='userGroupList'
					:to_data='dialogRowForm._userGroupIds'
					:defaultProps="{label:'label'}"
					@addBtn='() => {}'
					@removeBtn='() => {}'
					mode='transfer'
					height='340px'
					filter
					openAll></tree-transfer>

            </el-form-item>

            <el-form-item class="row-items-1 no-vercity" label="时间周期：" prop="timeCycle">
				<el-checkbox-group v-model="dialogRowForm._timeCycle" size="small" @change="changeTimeCycle">
					<el-checkbox-button v-for="timeCycle in timeCycles" :label="timeCycle" :key="timeCycle">{{timeCycle}}</el-checkbox-button>
				</el-checkbox-group>
            </el-form-item>

            <el-form-item class="row-items-2 no-vercity" label="是否开启：" prop="isOpen">
				<el-switch
					size="mini"
					class="switchStyle"
					v-model="dialogRowForm.isOpen"
					:active-value="1"
					:inactive-value="2"
					active-color="#00A854"
					active-text="开启"
					inactive-color="gray"
					inactive-text="关闭"
					@change="() => {}">
				</el-switch>
			</el-form-item>

            <el-form-item class="row-items-1 btn-form-item-c" style="padding-top: 20px;text-align: center;">
                <el-button type="primary" size="primary" @click.native="submit">{{dialogForm.submitButton}}</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

/* JS */
<script>

    // API 围栏信息
    import ApiFence from '@/request/api-fence'
    import {checkEmpty, checkFormat, validFormat} from "@/global/global-valid";
    // 组件 树形穿梭框
    import treeTransfer from 'el-tree-transfer' // 引入

    export default {
        /**
         * @Des 组件名
         * @Auth
         * @Date 2021/8/2
         */
        name: "FenceDialog",
        /**
         * @Des 数据定接收类型
         * @Auth
         * @Date  2021/8/2
         */
        props: {
            /**
             * @Des 人员组
             * @Auth
             * @Date 2021/8/2
             */
            userGroups: {
                type: Array,
                default: function (){
                    return []
                }
            },
        },
        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/8/2
         */
        components: {
            //组件 树形穿梭框
            treeTransfer,
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date  2021/8/2
         */
        data() {
			return {
				// 树形穿梭框
				treeTransferForm: {
					title: ['未关联人员组','已关联人员组'],

				},
				// 弹出层属性
				dialogForm: {
					title: "",
					isEdit: false,
					areaShow: false,
					dialogFormVisible: false,
					submitButton: ''
				},
				/**
				 * @Des 标签属性
				 * @Auth
				 * ate  2021/8/2
				 */
				dialogRowForm: {
               		// 区域id
               		areaId: '',
               		// 地图id
               		mapId: '',

               		// 围栏配置id
               		eConfId: '',
               		// 围栏 名称
               		eName: '',
               		// 围栏 绘制 类型
               		eDrawType: '1',
               		// 围栏 范围
               		points: [],
               		// 围栏 报警类型
               		eType: 1,
               		// 时间类型
               		timeType: 1,// 1 全天；2 时间段
               		// 时间间隔
               		timeSlot: '',
               		// 循环周期
               		timeCycle: "[\"星期一\",\"星期二\",\"星期三\",\"星期四\",\"星期五\",\"星期六\",\"星期日\"]",
               		// 循环周期
               		_timeCycle: [],
               		// 提示语
               		content: '',
               		// 是否布防
               		isOpen: 1,// 1 开启；2 关闭
               		// 处理方式
               		dealMethod: 1,// 1 系统自动，2 手动
               		// 是否允许
               		isAllow: 2,// 1 允许；2 不允许
               		// 人员组
               		userGroupIds: [],
               		// 人员组
               		_userGroupIds: [],
               		// 关联对象
               		relationType: 1,// 1  关联人；
               		// 规则
               		rules: '',
               		// 聚众范围
               		range: 'range',
               		// 聚众范围 宽
               		rangeX: '',
               		// 聚众范围 高
               		rangeY: '',
               		// 人数
               		peopleNum: '',
               		// 周界阈值
               		borderDis: '',
               		// 周界类型
               		borderType: 1,// 1 禁止进入，2 禁止离开
				},
				/**
				 * @Des 规则属性
				 * @Auth
				 * @Date  2021/8/2
				 */
				rules: {
					eName: [
						{ required: true, message: '请输入围栏名称', trigger: 'blur' },
					],
					dealmethod: [
						{ required: true, message: '请选择处理方式', trigger: 'blur' },
					],
					timeCycle: [
						{ required: true, message: '请选择时间周期', trigger: 'blur' },
					],
					isOpen: [
						{ required: true, message: '请选择是否开启', trigger: 'blur' },
					],
					range: [
						{ required: true, message: '请输入聚众范围', trigger: 'false' },
						{
                        	validator: (rule, value, callback) => {
	                            // 是否为空
	                            let xEmptyFlag = this.$checkEmpty(this.dialogRowForm.rangeX);
	                            let yEmptyFlag = this.$checkEmpty(this.dialogRowForm.rangeY);

	                            // 是否为数字
	                            let xNumFlag = parseFloat(this.dialogRowForm.rangeX) == this.dialogRowForm.rangeX;
	                            let yNumFlag = parseFloat(this.dialogRowForm.rangeY) == this.dialogRowForm.rangeY;

	                            if (xEmptyFlag && yEmptyFlag) {
	                            	new callback(new Error("请输入聚众范围 长度、宽度"));
	                            } else if (xEmptyFlag) {
	                                new callback(new Error("请输入聚众范围长度"));
	                            } else if (yEmptyFlag) {
	                                new callback(new Error("请输入聚众范围宽度"));
	                            } else if (!xNumFlag) {
	                                new callback(new Error("聚众范围长度应为数字"));
	                            } else if (!yNumFlag) {
	                                new callback(new Error("聚众范围宽度应为数字"));
	                            } else {
	                            	callback();
	                            }
	                        },
	                        trigger: "blur"
                        },
					],
					peopleNum: [
						{ required: true, message: '请输入聚众人数', trigger: 'blur' },
						{
                        	validator: (rule, value, callback) => {
	                            // 是否为数字
	                            let isInt = parseInt(value) == value;

	                            if (!isInt) {
	                            	new callback(new Error("聚众人数应为整数"));
	                            } else {
	                            	callback();
	                            }
	                        },
	                        trigger: "blur"
                        },
					],
					borderDis: [
						{ required: true, message: '请输入周界阈值', trigger: 'blur' },
						{
                        	validator: (rule, value, callback) => {
	                            // 是否为数字
	                            let isNumber = parseFloat(value) == value;

	                            if (!isNumber) {
	                            	new callback(new Error("周界阈值应为数字"));
	                            } else {
	                            	callback();
	                            }
	                        },
	                        trigger: "blur"
                        },
					],
					borderType: [
						{ required: true, message: '请选择周界类型', trigger: 'blur' },
					],
				},

				/**
				 * @Des 围栏 报警类型
				 * @Auth
				 * @Date  2021/8/2
				 */
				eTypes: [
					{label: '入界区域', val: 1},
					{label: '出界区域', val: 2},
					{label: '带离区域', val: 3},
					{label: '公共区域', val: 4},
					{label: '不可定位区域', val: 5},
				],
				/**
				 * @Des 处理方式
				 * @Auth
				 * @Date  2021/8/2
				 */
				dealMethods: [
					{label: '系统自动处理', val: 1},
					{label: '手动处理', val: 2},
				],
				/**
				 * @Des 周界类型
				 * @Auth
				 * @Date
				 */
				borderTypes: [
					{label: '禁止进入', val: 1},
					{label: '禁止离开', val: 2},
				],
				/**
				 * @Des 循环周期
				 * @Auth
				 * @Date  2021/8/2
				 */
				timeCycles: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
				/**
				 * @Des 人员组list
				 * @Auth
				 * @Date  2021/8/2
				 */
				userGroupList: [],
			}
        },
        mounted() {

        },
        /**
         * @Des 方法定义
         * @Auth
         * @Date  2021/8/2
         */
        methods: {
			/**
			 * @Des 穿梭框 筛选
			 * @Auth
			 * Date  2021/8/2
			 */
			filterMethod(query, item) {
            	return String(item.bsId).indexOf(query) > -1 || String(item.sid).indexOf(query) > -1;
            },
            /**
			 * @Des 刷新 人员组list
			 * @Auth
			 * Date  2021/8/2
			 */
			freshUserGroupList() {
				// 人员组list
				this.userGroupList = [];
				// 起始数据
				let fromeData = [];
				// 目标数据
				let toData = [];

				// 已配置
				let userGroupIds = this.dialogRowForm.userGroupIds;

				// 遍历 人员组
				this.userGroups.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row.children)) return true;

					let children = row.children;
					// 起始数据
					let fromeChildren = [];
					// 目标数据
					let toChildren = [];

					// 遍历
					children.forEach((r, i) => {

						// 已关联
						if (userGroupIds.indexOf(r.id) > -1) {
							// 目标数据
							toChildren.push(Object.assign({}, r, {key: r.id}));
						} else {
							// 起始数据
							fromeChildren.push(Object.assign({}, r, {key: r.id}));
						}

					});

					// 起始数据
					fromeChildren.length > 0 && fromeData.push(Object.assign({}, row, {key: row.id, children: fromeChildren}));
					// 目标数据
					toChildren.length > 0 && toData.push(Object.assign({}, row, {key: row.id, children: toChildren}));

				});

				// 人员组list
				this.userGroupList = fromeData;
				// 已关联
				this.dialogRowForm._userGroupIds = toData;

				// 是否允许
				this.dialogRowForm.isAllow = this.dialogRowForm.eType == 1 ? 1 : 2;

				let isAllowStr = this.dialogRowForm.isAllow == 1 ? '允许' : '不允许';
				// 标题
				let title = '已关联人员组';
				switch(String(this.dialogRowForm.eType)) {
					case '1':
						title = (isAllowStr + '入界的人员组');
						break;
					case '2':
						title = (isAllowStr + '出界的人员组');
						break;
					case '7':
						title = (isAllowStr + '聚众的人员组');
						break;
					case '8':
						title = (isAllowStr + '靠近周界的人员组');
						break;
					default:
						title = '已关联人员组';
				}

				// 目标穿梭框标题
				//this.treeTransferForm.title[1] = title;
				this.$set(this.treeTransferForm.title, 1, title);
			},
			/**
			 * @Des 刷新 关联人员组
			 * @Auth
			 * Date  2021/8/2
			 */
			freshUserGroupIds() {
				// 已关联
				let userGroupIds = [];
				// 已关联 人员组
				let _userGroupIds = this.dialogRowForm._userGroupIds;

				// 遍历 人员组
				_userGroupIds.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row.children)) return true;
					let children = row.children;

					// 遍历
					children.forEach((r, i) => {
						// 已关联
						userGroupIds.push(r.id);
					});
				});

				// 已关联
				this.dialogRowForm.userGroupIds = userGroupIds;
			},

			/**
			 * @Des 刷新 时间周期
			 * @Auth
			 * Date  2021/8/2
			 */
			freshTimeCycle() {
				// 时间周期
				let timeCycle = [];
				// 遍历
				this.timeCycles.forEach((value, index) => {
					if (this.dialogRowForm._timeCycle.indexOf(value) > -1) {
						timeCycle.push(value);
					}
				});
				// 时间周期
				this.dialogRowForm.timeCycle = timeCycle;
			},
			/**
			 * @Des 改变 时间周期
			 * @Auth
			 * Date  2021/8/2
			 */
			changeTimeCycle() {
				// 刷新 时间周期
				this.freshTimeCycle();
				// 校验
				this.$refs.dialogRowForm.validateField('timeCycle', error => {});
			},

			/**
			 * @Des 刷新 rules
			 * @Auth
			 * Date  2021/8/2
			 */
			freshRules() {
				// 聚众报警
				if (this.dialogRowForm.eType == 7) {
					this.dialogRowForm.rules = [[this.dialogRowForm.rangeX, this.dialogRowForm.rangeY].join(','), this.dialogRowForm.peopleNum].join(';');
				}

				// 周界报警
				if (this.dialogRowForm.eType == 8) {
					this.dialogRowForm.rules = [this.dialogRowForm.borderDis, this.dialogRowForm.borderType].join(';');
				}
			},

			/**
			 * @Des 刷新 初始数据
			 * @Auth
			 * Date  2021/8/2
			 */
			freshInitData() {
				// 刷新 人员组list
				this.freshUserGroupList();
				// 时间周期
				this.dialogRowForm._timeCycle = eval(this.dialogRowForm.timeCycle) ? JSON.parse(this.dialogRowForm.timeCycle) : [];

				// 聚众报警
				if (this.dialogRowForm.eType == 7) {
					let rules = this.dialogRowForm.rules.split(';');
					let XY = !this.$checkEmpty(rules[0]) ? rules[0].split(',') : [];
					// 聚众区域 宽
					this.dialogRowForm.rangeX = !this.$checkEmpty(XY[0]) ? parseFloat(XY[0]) : '';
					// 聚众区域 高
					this.dialogRowForm.rangeY = !this.$checkEmpty(XY[1]) ? parseFloat(XY[1]) : '';
					// 聚众人数
					this.dialogRowForm.peopleNum = !this.$checkEmpty(rules[1]) ? parseInt(rules[1]) : '';
				}

				// 周界报警
				if (this.dialogRowForm.eType == 8) {
					let rulers = !this.$checkEmpty(this.dialogRowForm.rules) ? this.dialogRowForm.rules.split(';') : [];
					// 周界阈值
					this.dialogRowForm.borderDis = !this.$checkEmpty(rulers[0]) ? parseFloat(rulers[0]) : '';
					this.dialogRowForm.borderType = !this.$checkEmpty(rulers[1]) ? parseInt(rulers[1]) : 1;
				}
			},
			/**
			 * @Des 刷新 表单数据
			 * @Auth
			 * Date  2021/8/2
			 */
			freshFormData() {
				// 刷新 关联人员组
				this.freshUserGroupIds();
				// 刷新 时间周期
				this.freshTimeCycle();
				// 刷新 rules
				this.freshRules();
			},

            /**
             * @Des 打开弹出层
             * @Auth
             * @Date  2021/8/2
             */
			openDialog(isEdit, title, data, index) {
				this.dialogForm.title = title;
				this.dialogForm.isEdit = isEdit;
				this.dialogForm.dialogFormVisible = true;
				this.dialogForm.submitButton = "保存围栏";

				// 重置
				this.reset();

                // 填充数据
                if (data) {
                    // console.log(data)
                    this.dialogRowForm = Object.assign({}, this.dialogRowForm, data);
                }

                // 刷新 初始数据
                this.freshInitData();
            },

            /**
             * @Des 提交数据
             * @Auth
             * @Date  2021/8/2
             */
            submit(){
                // 刷新 表单数据
				this.freshFormData();

				this.$refs.dialogRowForm.validate(valid => {
                    if(!valid) return false;

                    // 交互 参数
                    let formData = Object.assign({}, this.dialogRowForm, {
                    	projectId: this.$store.state.currentProjectId,
                    	eType: parseInt(this.dialogRowForm.eType),
                    });
                    let api = this.dialogForm.isEdit ? ApiFence.updateFenceApi : ApiFence.addFenceApi;
                    // 交互
                    this.$request.postJsonRequest(api, formData).then(result => {
                        if (result.code == 0) {
                            this.$message({
                                message: this.dialogForm.isEdit?'围栏编辑成功':'围栏添加成功！',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });

                            this.dialogForm.dialogFormVisible = false;

                            // 添加成功

                            // 取消绘制
                            this.$parent.cancelDraw();
                            // 查询围栏
                            this.$parent.searchFence();
                        } else {
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                    }).catch(error => {
                        console.error((this.dialogForm.isEdit ? '编辑' : '新增') + '电子围栏异常', api, error);
                    })
                })
            },
            /**
             * @Des 弹窗关闭
             * @Auth
             * @Date  2021/8/2
             */
            handleDialogClose() {
                this.reset();
                // 取消绘制
				this.$parent.cancelDraw();
            },
            /**
             * @Des 重置
             * @Auth
             * @Date  2021/8/2
             */
            reset() {
                this.cleanValidate('dialogRowForm');
                this.cleanData();
            },

            /**
             * @Des 清除表单验证
             * @Auth
             * @Date  2021/8/2
             */
            cleanValidate(formName) {
                // 清除表单校验的提示
                if (this.$refs[formName]) {
                    // 延时执行
                    this.$nextTick(function () {
                        this.$refs[formName].clearValidate();
                    })
                };
            },
            /**
             * @Des 清除数据
             * @Auth
             * @Date  2021/8/2
             */
			cleanData() {
				// 区域id
				this.dialogRowForm.areaId = '';
				// 地图id
				this.dialogRowForm.mapId = '';

				// 围栏配置id
				this.dialogRowForm.eConfId = '';
				// 围栏 名称
				this.dialogRowForm.eName = '';
				// 围栏 绘制 类型
				this.dialogRowForm.eDrawType = '1';
				// 围栏 范围
				this.dialogRowForm.points = [];
				// 围栏 报警类型
				this.dialogRowForm.eType = 1;
				// 时间类型
				this.dialogRowForm.timeType = 1;// 1 全天；2 时间段
				// 时间间隔
				this.dialogRowForm.timeSlot = '';
				// 循环周期
				this.dialogRowForm.timeCycle = "[\"星期一\",\"星期二\",\"星期三\",\"星期四\",\"星期五\",\"星期六\",\"星期日\"]";
				// 循环周期
				this.dialogRowForm._timeCycle = [];
				// 提示语
				this.dialogRowForm.content = '';
				// 是否布防
				this.dialogRowForm.isOpen = 1;// 1 开启；2 关闭
				// 处理方式
				this.dialogRowForm.dealMethod = 1;// 1 系统自动，2 手动
				// 是否允许
				this.dialogRowForm.isAllow = 2;// 1 允许；2 不允许
				// 人员组
				this.dialogRowForm.userGroupIds = [];
				// 人员组
				this.dialogRowForm._userGroupIds = [];
				// 关联对象
				this.dialogRowForm.relationType = 1;// 1  关联人；
				// 规则
               	this.dialogRowForm.rules = '';
               	// 聚众范围
               	this.dialogRowForm.range = 'range';
               	// 聚众范围 宽
               	this.dialogRowForm.rangeX = '';
               	// 聚众范围 高
               	this.dialogRowForm.rangeY = '';
               	// 人数
				this.dialogRowForm.peopleNum = '';
				// 周界阈值
				this.dialogRowForm.borderDis = '';
				// 周界类型
				this.dialogRowForm.borderType = 1;
			}

        }
    }
</script>

/* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		width: 800px;
		
		.el-input__inner {
			padding: 0 10px;
			font-size: 16px;
		}/* .el-input__inner */
		
		.el-select {
			.el-input__inner {
				padding-right: 30px;
			}/* .el-input__inne */
		}/* .el-select */
		
		/* 穿梭框 */
		.component-transfer {
			.filter-tree {
				.el-input__inner {
					padding: 0 5px;
					font-size: 12px;
				}
			}
		}
		
	}
</style>



// WEBPACK FOOTER //
// src/components_pages/Fence/FenceDialog.vue